/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

//react native imports
import { Dimensions } from 'react-native';

//phoenix imports
import { Orientation } from '@airasia-phoenix/react-native/utils/utils';

const Constants = {
  IMAGE_HEIGHT: 150,
  get CARD_WIDTH() {
    //card and image width will be approx same
    const screenWidth = Dimensions.get('window').width;
    const spaceInBetween = 12 * 2 + 16; //card spacing + left padding
    const cardAvailableSpace = screenWidth - spaceInBetween;
    const peekView = 2.15;
    return cardAvailableSpace / peekView;
  },
  INITIAL_LOAD_IMAGE_COUNT: 3,
  SUBSEQUENT_LOAD_IMAGE_COUNT: 3,
  CAROUSEL_HEIGHT: 290,
  get CAROUSEL_ORIENTATION() {
    const horizontalSpacingInCards = 12 / 2; //each card;
    const rowCount = 1;
    return new Orientation.Horizontal(0, rowCount, horizontalSpacingInCards, 0);
  },
  SCROLL_SPEED: 0.85,
};

export default Constants;
